import { useRef, useState } from "react";
import CustomButton from "../../../common/CustomButton";
import GoalOptionTile from "../../../common/GoalOptionTile";
import { Forward, Back } from "../../../common/CustomIcons";
import Slider from "react-slick";
import { ScreenType } from "../../../utils/breakpoints";
import { useMediaQuery } from "@mui/material";


function SlideSelectGoals(props) {
    const [selectedGoals, setSelectedGoals] = useState([]);
    const sliderRef = useRef(null);
    const screenSize = ScreenType(useMediaQuery);


    const updateOptions = (goal) => {
        if (selectedGoals.includes(goal)) {
            setSelectedGoals(selectedGoals.filter((d) => d !== goal));
        } else {
            setSelectedGoals([...selectedGoals, goal]);
        }
    }

    let disable = selectedGoals.length < 3;

    const settings = {
        dots: true,
        centerMode: true,
        infinite: true,
        slidesToShow: 2,
        speed: 500,
        rows: 2,
        slidesPerRow: 2,
        swipeToSlide: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style }}
                onClick={onClick}
            >
                <Forward />
            </div>
        );
    }

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style }}
                onClick={onClick}
            >
                <Back />
            </div>
        );
    }

    return (
        <div id="uo-select-goals" className="uo-component">
            <div id="uo-goal-form" className="ou-with-text">
                <h4>Set Your Goals</h4>
                <h6>Select three fitness goals to help us recommend the best programs for you.</h6>

                {
                    screenSize == "xl"
                        ? <div id="uo-gf-goals-web">
                            <Slider {...settings}>
                                {
                                    props?.surveyGoals?.map((sg, i) => {
                                        let disableTile = (!selectedGoals?.includes(sg?.id) && selectedGoals?.length > 2);
                                        return (
                                            <div>
                                                <div onClick={() => {
                                                    if (!disableTile) {
                                                        updateOptions(sg?.id);
                                                    }
                                                }}>
                                                    <GoalOptionTile label={sg?.title} svg={sg?.svg} className={`${selectedGoals?.includes(sg?.id) && "active-tile"} ${disableTile && "disable-tile"}`} />
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </Slider>
                        </div>
                        : <div id="uo-gf-goals">
                            {
                                props?.surveyGoals?.map((sg, i) => {
                                    let disableTile = (!selectedGoals?.includes(sg?.id) && selectedGoals?.length > 2);
                                    return (
                                        <div onClick={() => {
                                            if (!disableTile) {
                                                updateOptions(sg?.id);
                                            }
                                        }}>
                                            <GoalOptionTile label={sg?.title} svg={sg?.svg} className={`${selectedGoals?.includes(sg?.id) && "active-tile"} ${disableTile && "disable-tile"}`} />
                                        </div>
                                    )
                                })
                            }
                        </div>
                }


                <CustomButton disabled={disable} id="uo-sg-button" className="uo-button active" onClick={() => {
                    props?.moveNext();
                    props?.setPreRegistrationDetails(prd => ({
                        ...prd,
                        goals: selectedGoals
                    }));
                }}>Continue</CustomButton>
            </div>
        </div>
    );
}

export default SlideSelectGoals;